import { computed, useContext } from "@nuxtjs/composition-api"
import { getName } from "@cospired/i18n-iso-languages"

import { useProfessionalLanguageQuery } from "@/api/query/languagesQuery"

export default function () {
  const { data: locales } = useProfessionalLanguageQuery()
  const { app } = useContext()
  const locale = computed(() => app.i18n.locale.split("-")[0])

  const allProfessionalLanguageNames = computed(() => {
    if (!locales.value) return []
    const langNames = locales.value
      .filter((l) => l.enabled)
      .map((l) => {
        return {
          id: l.id,
          name: getName(l.id, locale.value) ?? l.id,
        }
      })
      .filter((l) => l.name !== undefined)

    return langNames
  })

  return { allProfessionalLanguageNames }
}
